import type { Provenance, SummaryValue } from './provenance.js'

/**
 * Policy introspection (`summary-calculation` spec: "Calculation policy
 * is configurable and inspectable"). UI wiring (a settings panel) lives
 * in `apps/web`; this is the read-only API it will call into to show
 * which strategy produced which displayed value.
 */

export interface PolicyDescription {
  strategy: Provenance
  explanation: string
}

const EXPLANATIONS: Record<Provenance, string> = {
  original: 'Read unchanged from the source file’s summary message.',
  recalculated: 'Recalculated from retained device-measured data.',
  estimated: 'Estimated — derived geometrically or proportionally, not measured directly.',
  edited: 'Set manually in this editor — not measured by the device or recalculated.',
  unavailable: 'Not available — cannot be accurately reconstructed from retained data.',
}

export function describeSummaryValue(value: SummaryValue<unknown>): PolicyDescription {
  return { strategy: value.provenance, explanation: EXPLANATIONS[value.provenance] }
}

export function describePolicy(
  summary: Record<string, SummaryValue<unknown>>,
): Record<string, PolicyDescription> {
  const result: Record<string, PolicyDescription> = {}
  for (const [category, value] of Object.entries(summary)) {
    result[category] = describeSummaryValue(value)
  }
  return result
}
